// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IxMQj","footer":"styles_footer__1ZbSs","passCodeTooltip":"styles_passCodeTooltip__2iJsr"};